// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/stylesheet/main.style.scss
 ** module id = 452
 ** module chunks = 1
 **/